import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-drs-fee-logo',
  templateUrl: './drs-fee-logo.component.html',
  styleUrls: ['./drs-fee-logo.component.scss'],
})
export class DrsFeeSignComponent {
  @Input() containerWidth = 54;
  @Input() containerHeight = 52;
  @Input() logoWidth = 80;
}
